import {
  LOAN_TYPE,
  CREDIT_CARD_TYPE,
  CURRENT_TYPE,
  BUSINESS_CURRENT_ACCOUNT
} from 'constants/general';

const getValidCurrentAccounts = (accounts) => {
  return accounts.filter(
    (account) =>
      account.type.toLowerCase() === CURRENT_TYPE &&
      account.product.name.toLowerCase() !== BUSINESS_CURRENT_ACCOUNT &&
      account.actions_available['/account/payments/transfer/in']
  );
};

const getEligibleAccounts = (accountList = []) => {
  const accounts = accountList.filter(
    (account) =>
      account.type === LOAN_TYPE ||
      account.type === CREDIT_CARD_TYPE ||
      (account.type === CURRENT_TYPE &&
        account.balances[0].amount.value !== account.balances[1].amount.value)
  );

  return accounts;
};

const getMainAccountName = (accounts) => {
  const mainAccount = accounts.accountList.find(
    (account) => account.id === accounts.mainBankAccountId
  );
  if (mainAccount && mainAccount.metadata && mainAccount.metadata.account_name) {
    return mainAccount.metadata.account_name;
  } else {
    return mainAccount && mainAccount.product.name;
  }
};

const getMainAccount = (accounts) =>
  accounts.accountList.find((account) => account.id === accounts.mainBankAccountId);

const getAccountNumber = (account) => {
  const [, accountNumber] = account.number.split('-');
  return accountNumber;
};

const getSortCode = (account) => {
  const [sortCode] = account.number.split('-');
  return sortCode;
};

const formatSortCode = (sortCode) => {
  return sortCode !== null
    ? `${sortCode.slice(0, 2)}-${sortCode.slice(2, 4)}-${sortCode.slice(-2)}`
    : null;
};

const hasValidCurrentAccount = (accounts) => getValidCurrentAccounts(accounts).length > 0;

export {
  getValidCurrentAccounts,
  getEligibleAccounts,
  formatSortCode,
  getMainAccountName,
  getMainAccount,
  getAccountNumber,
  getSortCode,
  hasValidCurrentAccount
};
